import React from "react";

const IconLikeSvg = ({ isActive }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23 8.15423C23 4.75531 20.2828 2 16.9314 2C14.8968 2 13.1015 3.01843 12 4.57507C10.8985 3.01843 9.10316 2 7.06922 2C3.71725 2 1 4.75469 1 8.15423C1 8.63569 1.06027 9.10219 1.1636 9.55184C2.00621 14.861 7.82757 20.4621 12 22C16.1718 20.4621 21.9938 14.861 22.8352 9.55247C22.9397 9.10281 23 8.63632 23 8.15423Z"
        fill={isActive ? "#F98723" : "#fff"}
      />
    </svg>
  );
};

export default IconLikeSvg;
